import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    userInfo: null,
    isLogged: false,
    hideRight: true,
    acceptFileType: ".docx,.doc,.pdf,.caj,.txt,.pptx,.ppt,.DOCX,.DOC,.PDF,.CAJ,.TXT,.PPTX,.PPT",
    socketConnectOnOutline:false//是否点击上线或下线按钮
  },
  mutations: {
    setState(state, data){
      state[data.key] = data.value
    },
    setSocketConnectOnOutline(state, param) {
      state.socketConnectOnOutline = param
    }
  },
  actions: {},
  modules: {

  }
});
export default store;